var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSorting = function SvgSorting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D0D0D",
    fillRule: "evenodd",
    d: "M5.5 5.5 8.024 8l-.705.71-1.315-1.301V12.5h-.005v5.093l1.317-1.302.705.709-2.52 2.497L2.982 17l.705-.71 1.312 1.298V12.5h.005V7.404L3.683 8.71 2.98 8zM21 8H10v1h11zm-11 4h9v1h-9zm0 4h8v1h-8z",
    clipRule: "evenodd"
  })));
};
export default SvgSorting;